import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  'de_at': {
    'show all': 'Alle anzeigen',
    'previous': 'Zurück',
    'next': 'Weiter',
    'recipes': 'Rezepte',
    'categories': 'Kategorien',
    'menus': 'Menüs',
    'wiki': 'Kochlexikon',
    'blog articles': 'Blog Artikel',
    'ingredients': 'Zutaten',
    'Enjoy your meal!': 'Mahlzeit!!',
    'Thank you': 'Danke'
  },
  'en': {
    'show all': 'show all',
    'previous': 'previous',
    'next': 'next',
    'recipes': 'recipes',
    'categories': 'categories',
    'menus': 'menus',
    'wiki': 'wiki',
    'blog articles': 'blog articles',
    'ingredients': 'ingredients',
    'Enjoy your meal!': 'Enjoy your meal!',
    'Thank you': 'Thank you'
  },
  'cs': {
    'show all': 'Zobrazit vše',
    'previous': 'zpět',
    'next': 'více',
    'recipes': 'recepty',
    'categories': 'kategorie',
    'menus': 'nabídky',
    'wiki': 'Encyklopedie vaření',
    'blog articles': 'Článek blogu',
    'ingredients': 'přísady',
    'Enjoy your meal!': 'Dobrou chuť!!',
    'Thank you': 'Děkuji'
  },
  'hu': {
    'show all': 'Összes megjelenítése',
    'previous': 'előző',
    'next': 'következő',
    'recipes': 'receptek',
    'categories': 'Kategóriák',
    'menus': 'menük',
    'wiki': 'főzés enciklopédiája',
    'blog articles': 'Blog cikk',
    'ingredients': 'összetevők',
    'Enjoy your meal!': 'Jó étvágyat!!',
    'Thank you': 'Köszönöm'
  },
  'fr': {
    'show all': 'Tout afficher',
    'previous': 'précédent',
    'next': 'Prochain',
    'recipes': 'recettes',
    'categories': 'Catégories',
    'menus': 'menus',
    'wiki': 'Encyclopédie cuisine',
    'blog articles': 'Article de blog',
    'ingredients': 'ingrédients',
    'Enjoy your meal!': 'Bon appétit!!',
    'Thank you': 'Je vous remercie'
  }
}

const lang = window.__INIT_DATA.lang || 'de_at'

export default new VueI18n({
  locale: lang,
  fallbackLocale: lang === 'de_de' ? 'de_at' : 'en',
  messages
})



// WEBPACK FOOTER //
// ./src/locales/index.js